import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

import AccountApi from 'mewe/api/account-api';
import ContactsApi from 'mewe/api/contacts-api';
import ChatApi from 'mewe/api/chat-api';
import CurrentUserStore from 'mewe/stores/current-user-store';
import dispatcher from 'mewe/dispatcher';
import config from 'mewe/config';

export default class AppSettings extends Component {
  @service router;

  @tracked loaded;
  @tracked selectedNavItem = this.navItems[0];

  @tracked navItems = [
    { label: __('My Account'), route: 'app.settings.account', icon: 'user', dataTestId: 'my-settings-my-account' },
    { label: __('Subscription & Purchases'), route: 'app.settings.purchases', icon: 'shop', dataTestId: 'my-settings-subscriptions-and-purchase' },
    { label: __('Privacy & Sharing'), route: 'app.settings.privacy', icon: 'shield', dataTestId: 'my-settings-privacy-sharing' },
    { label: __('Notification & Alerts'), route: 'app.settings.notification', icon: 'notification', dataTestId: 'my-settings-notification-alerts' },
    { label: __('Preferences'), route: 'app.settings.preferences', icon: 'setting-4', dataTestId: 'my-settings-feed-preferences' },
    { label: __('Groups'), route: 'app.settings.groups', icon: 'category-2', dataTestId: 'my-settings-groups' },
  ];

  constructor() {
    super(...arguments);

    CurrentUserStore.getState().deferred.promise.then(() => {
      this.loaded = true;
    });

    Promise.all([
      AccountApi.getData(),
      AccountApi.getSpaceUsedStatus(),
      ContactsApi.getMyContactsSettings(),
      ChatApi.isChatRequestsAllowed(),
    ]).then((data) => {
      this.storeSettings(data);
    });

    if (config.environment !== 'prod') {
      this.navItems.push({ label: __('Apps'), route: 'app.settings.apps', icon: 'three-d-cube', dataTestId: 'my-settings-apps' });
    }
  }

  storeSettings(data) {
    let accountSettings = data[0];
    let cloudStorage = data[1];
    let contactsSettings = data[2];
    let chatRequests = data[3];

    let settings = {
      timezones: accountSettings.timezones,
      cloudStorage: cloudStorage,
    };

    settings.account = accountSettings;

    settings.privacy = {
      public: accountSettings.public,
      allowSearchDirectory: accountSettings.active,
      hideFollowers: accountSettings.hideFollowers,
      allowChatRequests: chatRequests ? chatRequests.allowRequests : false,
    };

    settings.notifs = {
      emailNotifications: accountSettings.emailNotifications,
      allowChatMsgSound: contactsSettings.allowChatMsgSound,
      allowNotifSound: contactsSettings.allowNotifSound,
    };

    dispatcher.dispatch('client-data', 'saveClientPreference', 'settings', settings);
  }

  @action
  selectNavItem(item) {
    this.selectedNavItem = item;
    this.router.transitionTo(item.route);
  }
}
